import { observer } from 'mobx-react-lite';

import { SlotItem } from '../SlotItem';

import { SlotListProps } from './interfaces';
import styles from './SlotList.module.scss';

const SlotList = ({
  selectedSlotId,
  selectedDate,
  onSlotSelect,
  priceWithoutDelivery,
  deliverySlots,
}: SlotListProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        {selectedDate &&
          deliverySlots[selectedDate]?.map((slot) => (
            <SlotItem
              key={`${slot.schedule_slot_id}${slot.current_date}`}
              slot={slot}
              priceWithoutDelivery={priceWithoutDelivery}
              onSelect={onSlotSelect}
              isSelected={slot.schedule_slot_id === selectedSlotId}
            />
          ))}
      </div>
    </div>
  );
};

export default observer(SlotList);
